/* eslint-disable */
export const menuData = [
    {
        path: '/learninghome',
        name: 'learningHome',
        title: '홈',
    },
    {
        path: '/note',
        name: 'myNote',
        title: '마이노트',
    },
    {
        path: '/incorrectnote',
        name: 'myNote-wrongNote',
        title: '오답노트',
    },
    {
        path: '/killernote',
        name: 'myNote-killerNote',
        title: '심화노트',
    },
    {
        path: '/analysisreport',
        name: 'report',
        title: '학습분석리포트',
    },
    {
        path: '/dailyreport',
        name: 'report-dailyReport',
        title: '일분석리포트',
    },
    {
        path: '/satreport',
        name: 'report-satReport',
        title: '수능모의평가분석리포트',
    },


    {
        path: '/corereading',
        name: 'coreReading',
        title: '코어독해',
    },
    {
        path: '/authenticreading',
        name: 'authenticReading',
        title: '본격독해',
    },
    {
        path: '/vocabularylearning',
        name: 'vocabularyLearning',
        title: '어휘학습',
    },
    {
        path: '/sat',
        name: 'sat',
        title: '수능모의평가',
    },

    {
        path: '/mypage',
        name: 'myPage',
        title: '마이페이지',
    },
    {
        path: '/userinfo',
        name: 'myPage-userinfo',
        title: '유저정보',
    },
    {
        path: '/inform',
        name: 'myPage-inform',
        title: '학습알림',
    },
    {
        path: '/settings',
        name: 'settings',
        title: '설정',
    },
    {
        path: '/map',
        name: 'userMapMain',
        title: '유저맵',
    },

    ////////////////----진단평가 ----/////////////
    {
        path: '/eval-login',
        name: 'eval_login',
        title: '진단평가 로그인',
    },
    {
        path: '/eval-member',
        name: 'eval_login_mem',
        title: '진단평가 멤버 로그인',
    },

    {
        path: '/eval-test',
        name: 'eval_qbank',
        title: '진단평가 테스트',
    },
    {
        path: '/eval-report',
        name: 'eval_report',
        title: '진단평가 report',
    },
    {
        path: '/faq',
        name: 'settings-faq',
        title: 'faq',
    },
    // {
    //     path: '/test',
    //     name: 'testPage',
    //     title: '파싱 테스트',
    // },
    // {
    //     path: '/test-core',
    //     name: 'testCore',
    //     title: '코어문제 테스트',
    // },
    // {
    //     path: '/test-authentic',
    //     name: 'testAuthentic',
    //     title: '본격문제 테스트',
    // },
    // {
    //     path: '/test-voca',
    //     name: 'testVoca',
    //     title: '어휘문제 테스트',
    // },
    // {
    //     path: '/test-sat',
    //     name: 'testSat',
    //     title: '수능문제 테스트',
    // },

];
